import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { RouteEnum, useRoute } from "../../contextApis/RouteContext";
import { useUserSessionContext } from "../../contextApis/UserSessionContext";
import Logout from "../common/Logout/Logout";
import Navigation from "../common/Navigation/Navigation";
import DrayageSearch from "../Drayage/Search/Search";
import LogIn from "../LogIn/LogIn";
import OTRSearch from "../OTR/Search/Search";
import Home from "../Home/Home";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    overflow: "hidden",
  },
});

const Router: React.FC = () => {
  const styles = useStyles();
  const { currentRoute } = useRoute();
  const { isLoggedIn } = useUserSessionContext();

  const renderContent = () => {
    switch (currentRoute) {
      case RouteEnum.DRAYAGE_SEARCH:
        return <DrayageSearch />;
      case RouteEnum.OTR_SEARCH:
        return <OTRSearch />;
      case RouteEnum.HOME:
        return <Home />;
      case RouteEnum.SIGN_IN:
        return <LogIn />;
      default:
        return <Home />;
    }
  };

  return (
    <div className={styles.container}>
      <Navigation isLoggedIn={isLoggedIn} />
      {renderContent()}
      <Logout />
    </div>
  );
};

export default Router;
